import { Pair } from '@app/analytics/metric-widget/data-objects/pair';

export class QueryResult<K> {
  constructor(public values: Pair<K, number>[], public max: number, public suffix: string) {}
}
